/**
 * Design Service Cart Cleanup
 *
 * Ana ürün sepetten çıkarıldığında, ona bağlı tasarım servisi
 * otomatik olarak silinir (_for_product property'sine göre eşleştirme).
 */

let _cleanupInProgress = false;

async function _runDesignServiceCleanup() {
  // Kısa bekleme: sepet güncellemesinin tamamlanmasını bekle
  await new Promise((r) => setTimeout(r, 150));

  try {
    const res = await fetch('/cart.js');
    if (!res.ok) return;
    const cart = await res.json();

    // Tasarım servisi olmayan ana ürünlerin ID listesi
    const mainProductIds = new Set(
      cart.items
        .filter((item) => !item.properties?.['_for_product'])
        .map((item) => String(item.product_id))
    );

    // Ana ürünü artık sepette olmayan tasarım servisleri
    const orphaned = cart.items.filter(
      (item) =>
        item.properties?.['_for_product'] &&
        !mainProductIds.has(item.properties['_for_product'])
    );

    if (orphaned.length === 0) return;

    const updates = {};
    orphaned.forEach((svc) => {
      updates[svc.key] = 0;
    });

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.getAttribute('data-section-id'))
      .filter(Boolean);

    /** @type {Record<string, any>} */
    const body = { updates };
    if (sectionIds.length > 0) body.sections = sectionIds.join(',');

    const updateRes = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    const data = await updateRes.json().catch(() => ({}));

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { sections: data.sections ?? {} },
      })
    );
  } catch (err) {
    console.error('[DesignServiceCleanup]', err);
  }
}

document.addEventListener('cart:update', () => {
  if (_cleanupInProgress) return;
  _cleanupInProgress = true;
  _runDesignServiceCleanup().finally(() => {
    _cleanupInProgress = false;
  });
});
